import { css } from 'astroturf';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';
import React from 'react';

const { renderToStaticMarkup } = require('react-dom/server');

function escapeDoubleQuotes(str) {
  return str.replace(/\\([\s\S])|(")/g, '\\$1$2'); // thanks @slevithan!
}

function renderHTML(rawMDX) {
  return escapeDoubleQuotes(renderToStaticMarkup(React.createElement(MDXRenderer, null, rawMDX)));
}

const styles = css`
  .accordion {
    margin-bottom: 2rem;

    .item + .item {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    summary {
      padding: 1rem;
      cursor: pointer;
      color: #107db5;
      font-size: 1.125rem;
      transition: 0.25s ease-in-out color;
      display: flex;
      align-items: center;

      &:hocus {
        color: #000;
      }

      &::before {
        display: inline-block;
        content: '';
        height: 8px;
        width: 8px;
        margin-right: 12px;
        border-bottom: 2px solid currentColor;
        border-right: 2px solid currentColor;
        transform: rotate(-45deg);
        transition: 0.25s ease-in-out transform;
      }
    }

    details[open] summary::before {
      transform: rotate(45deg) translateY(-0.25rem);
    }

    details::details-content {
      overflow: clip;
      text-wrap: pretty;
      interpolate-size: allow-keywords;
      opacity: 0;
      height: 0;
      padding: 0rem 1rem 0rem;
      transition:
        opacity 0.25s ease-in-out,
        height 0.25s ease-in-out,
        padding-bottom 0.25s ease-in-out,
        content-visibility 0.25s ease-in-out allow-discrete;
    }

    details[open]::details-content {
      opacity: 1;
      padding: 1rem 1rem 2rem;
      height: auto;
    }
  }
`;

class FAQListing extends React.Component {
  getDocList() {
    const docList = [];
    this.props.docEdges.forEach((docEdge) => {
      docList.push({
        title: docEdge.node.frontmatter.title,
        category: docEdge.node.frontmatter.category,
        body: docEdge.node.body,
        slug: docEdge.node.fields.slug.split('/')[1],
      });
    });
    return docList;
  }

  render() {
    const docList = this.getDocList();

    const jsonLD = `{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [${docList
        .map(
          (post) => `{
          "@type": "Question",
          "name": "${post.title}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${renderHTML(post.body)}"
          }
        }
          `
        )
        .join(',')}]
    }`;

    return (
      <>
        <h3>Usage</h3>
        <div className={styles.accordion}>
          {docList
            .filter((post) => post.category === 'usage')
            .map((post) => (
              <details className={styles.item} key={post.title}>
                <summary className={styles.header}>{post.title}</summary>
                <div className="childPadding">
                  <MDXRenderer>{post.body}</MDXRenderer>
                </div>
              </details>
            ))}
        </div>

        <h3>Subscription</h3>
        <div className={styles.accordion}>
          {docList
            .filter((post) => post.category === 'subscription')
            .map((post) => (
              <details className={styles.item} key={post.title}>
                <summary className={styles.header}>{post.title}</summary>
                <div className="childPadding">
                  <MDXRenderer>{post.body}</MDXRenderer>
                </div>
              </details>
            ))}
        </div>

        <h3>Other</h3>
        <div className={styles.accordion}>
          {docList
            .filter((post) => post.category === 'other')
            .map((post) => (
              <details className={styles.item} key={post.title}>
                <summary className={styles.header}>{post.title}</summary>
                <div className="childPadding">
                  <MDXRenderer>{post.body}</MDXRenderer>
                </div>
              </details>
            ))}
        </div>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLD }} />
      </>
    );
  }
}

export default FAQListing;
